import { useEffect, useState } from 'react';
import './App.css';

function ClockCurrentDateAndTime() {

    const [currentTime, setCurrentTime] = useState('');
    const [currentDate, setCurrntDate] = useState('');
    const updateDateTime = () => {
        let dateTime = new Date();
        let date = dateTime.toLocaleDateString()
        // let time = dateTime.toLocaleTimeString();

        let h = dateTime.getHours();
        let m = dateTime.getMinutes();
        let s = dateTime.getSeconds();
        // let ms = dateTime.getMilliseconds();
        let am_pm = (h >= 12) ? 'PM' : 'AM';
        if (am_pm === 'PM') {
            h -= 12;
        }
        if (h<10) {h="0"+h;}
        if (m<10) {m="0"+m;}
        if (s<10) {s="0"+s;}
        let formattedTime = h + ':' + m + ':' + s;
        // let formattedTime = h + ':' + m + ':' + s + ':' + ms.toString();
        
        setCurrntDate(date);
        setCurrentTime(formattedTime +" "+ am_pm);
    }
    useEffect(() => {
        const intervalId = setInterval(updateDateTime, 100);

        return () => {
            clearInterval(intervalId);
        };
    }, []);

  return (
    <>
      <center>
        <div className='border'>
          <h2>{currentDate}</h2>
          <h2>{currentTime}</h2>
        </div>
      </center>
    </>
  );
}

export default ClockCurrentDateAndTime;
